import { SimpleModal } from '@livable/saas-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PostPaymentForm } from './PostPaymentForm';
const PostPaymentModal = _ref => {
  let accountId = _ref.accountId,
    handleClose = _ref.handleClose,
    isOpen = _ref.isOpen,
    propertyId = _ref.propertyId,
    handleRefreshTrigger = _ref.handleRefreshTrigger;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    noLeftButton: true,
    title: t('resident_account.post_payment')
  }, /*#__PURE__*/React.createElement(PostPaymentForm, {
    accountId: accountId,
    handleClose: handleClose,
    propertyId: propertyId,
    handleRefreshTrigger: handleRefreshTrigger
  }));
};
export default PostPaymentModal;